export enum ReportType {
  REPORTS = 'reports',
  SUBAFFILIATE_REPORTS = 'subaffiliate_reports',
  CREATIVE_REPORTS = 'creative_reports',
}

export enum ReportWidgetType {
  SEGMENTS = 'segments',
  STRUCTURES = 'structures',
}
